// extracted by mini-css-extract-plugin
export var icon = "_5v-1";
export var subtext = "_5v-0";